import { Avatar, Col } from "antd";
import React from "react";

const QuestionBadges = ({
  goal = { questions: [] },
  handleQuestionClick = () => {},
}) => {
  const { questions, question_status } = goal;
  const getBadgeStyle = (answers = []) => {
    let allYes = true;
    let allNo = true;
    let allNone = true;

    for (const answer of answers) {
      if (answer?.answer !== "Yes") allYes = false;
      if (answer?.answer !== "No") allNo = false;
      if (answer?.answer) allNone = false;
      // Early exit if none of the conditions are met
      if (!allYes && !allNo && !allNone) break;
    }
    if (allYes) return "badge-yes";
    if (allNo) return "badge-no";
    if (allNone) return "badge-none";
    return "badge-mixed";
  };
  const getStatusStyle = (isAnswered = true) => {
    if (isAnswered) return "badge-answered";
    return "badge-none";
  };
  const formatBadgeNumber = (value, index) => {
    const number = value ?? index + 1;
    return number < 10 ? `0${number}` : number;
  };

  if (questions) {
    return [...questions]
      .sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0))
      .map((question = {}, index) => {
        const badgeNumber = formatBadgeNumber(question?.order, index);
        const badgeStyle = getBadgeStyle(question?.answers);
        return (
          <Col
            key={question?.id ?? index + 1}
            style={{ marginBottom: "20px" }}
            className="gutter-row"
            flex="18%"
          >
            <Avatar
              onClick={() => handleQuestionClick(question)}
              shape="square"
              className={`question-badge ${badgeStyle}`}
            >
              {badgeNumber}
            </Avatar>
          </Col>
        );
      });
  } else {
    return question_status.map((question = {}, index) => {
      const badgeNumber = formatBadgeNumber(question?.order, index);
      const badgeStyle = getStatusStyle(question?.has_answered);
      return (
        <Col
          key={question?.id ?? index + 1}
          style={{ marginBottom: "20px" }}
          className="gutter-row"
          flex="18%"
        >
          <Avatar
            onClick={() => handleQuestionClick(question?.id)}
            shape="square"
            className={`question-badge ${badgeStyle}`}
          >
            {badgeNumber}
          </Avatar>
        </Col>
      );
    });
  }
};

export default QuestionBadges;
